import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './campForm.module.css';
import { showErrorToast } from '../../../../code/ToastHelper';

export default function CampForm({ camp, onClose, onSave }) {
    const [formData, setFormData] = useState({
        title: '',
        slug: '',
        maxParticipants: '',
    });

    useEffect(() => {
        if (camp) {
            setFormData({
                title: camp.title || '',
                slug: camp.slug || '',
                maxParticipants: camp.max_participants || '',
            });
        }
    }, [camp]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            let action = camp?.id ? 'update' : 'create';
            if (camp?.id) {
                await axios.put(`/api/camp/${camp.id}`, formData);
            } else {
                await axios.post('/api/camp', formData);
            }
            if (onSave) onSave(camp?.id || null, action);
            onClose();
        } catch (err) {
            console.error('Fehler beim Speichern des Camps:', err);
            showErrorToast('Fehler beim Speichern. Bitte versuche es erneut.');
        }
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalForm}>
                <h2>{camp ? 'Camp bearbeiten' : 'Neues Camp anlegen'}</h2>
                <form onSubmit={handleSubmit} className={styles.form}>
                    <label>
                        Camp Titel:
                        <input
                            type="text"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            required
                        />
                    </label>

                    <label>
                        Slug:
                        <input
                            type="text"
                            name="slug"
                            value={formData.slug}
                            onChange={handleChange}
                        />
                    </label>

                    <label>
                        Max. Teilnehmer:
                        <input
                            type="number"
                            name="maxParticipants"
                            min="1"
                            value={formData.maxParticipants}
                            onChange={handleChange}
                        />
                    </label>

                    <div className={styles.actions}>
                        <button type="submit" className={styles.save}>Speichern</button>
                        <button type="button" className={styles.cancel} onClick={onClose}>Abbrechen</button>
                    </div>
                </form>
            </div>
        </div>
    );
}